import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-center" }
const _hoisted_2 = { class: "d-flex justify-center" }
const _hoisted_3 = { class: "d-flex justify-center" }
const _hoisted_4 = { class: "d-flex justify-center" }
const _hoisted_5 = { class: "d-flex justify-center" }

import getDailyReportEditStatus from '@/types/responses/getDailyReportEditStatus';
import { formatDateTime } from '@/services/functions';
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'MergeFormDetail',
  props: {
    deliveryPlanChildren: {}
  },
  setup(__props: any) {

const props = __props;

function changeFormat(dateTime: string | null) {
  return dateTime ? formatDateTime(new Date(dateTime)) : '';
}

return (_ctx: any,_cache: any) => {
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_col = _resolveComponent("v-col")!

  return (_openBlock(), _createBlock(_component_v_col, { cols: "8" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_table, null, {
        default: _withCtx(() => [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _cache[0] || (_cache[0] = _createElementVNode("th", null, null, -1)),
              _createElementVNode("th", null, [
                _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.mergeForm.leavingWarehouse')), 1)
              ]),
              _createElementVNode("th", null, [
                _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.mergeForm.returningWarehouse')), 1)
              ])
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.deliveryPlanChildren, (child, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.mergeForm.tripId')) + " " + _toDisplayString(child.delivery_plan_id), 1)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_4, _toDisplayString(changeFormat(child.delivery_plan_vehicle_information.leaving_warehouse_date_time)), 1)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(changeFormat(child.delivery_plan_vehicle_information.returning_warehouse_date_time)), 1)
                ])
              ]))
            }), 128))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})